export default {
  'promoHeader': 'Did you remember?',
  'add':'Add',
  'pickSize':'Choose Size',
  'cartHeader':'Your cart:',
  'addUniid':'Add name and number',
  'remove':'Remove',
  'freeDeilvery':'Hey, you got free delivery!',
  'toCheckout':'Continue to checkout',
  'totalPrice':'Total:',
  'totalDiscount':'Discount total:',
  'deliveryPrice':'Delivery price:',
  'size':'Size:',
  'getTomoz':'',
  'totalVAT':'VAT total:',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}